import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card } from 'react-bootstrap';

const ProductCards = ({ heading1 = 'Robotic Automation', features = [], onFeatureClick }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <Container fluid className="py-5">
      <Container>
        {/* Heading Section */}
        <Row className="mb-4 text-center">
          <Col>
            <h2 style={{ fontSize: '2rem', fontWeight: 'bold' }}>{heading1}</h2>
          </Col>
        </Row>

        {/* Features Section */}
        <Row>
          {features.map((feature, index) => (
            <Col key={index} md={4} className="mb-4">
              <Card
                className="h-100 border-0 shadow-sm"
                style={{
                  transform: hoveredIndex === index ? 'scale(1.05)' : 'scale(1)',
                  transition: 'transform 0.3s ease-in-out',
                }}
                role={onFeatureClick ? 'button' : undefined}
                onClick={() => onFeatureClick && onFeatureClick(feature)}
                tabIndex={onFeatureClick ? 0 : undefined}
                onKeyPress={(e) => {
                  if (onFeatureClick && (e.key === 'Enter' || e.key === ' ')) onFeatureClick(feature);
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <Card.Img
                  variant="top"
                  src={feature.imageSrc}
                  alt={feature.imageAlt}
                  style={{ height: '200px', objectFit: 'cover' }}
                />
                <Card.Body>
                  <Card.Title style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                    {feature.title}
                  </Card.Title>
                  <Card.Text>{feature.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
};

ProductCards.propTypes = {
  heading1: PropTypes.string,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      imageSrc: PropTypes.string,
      imageAlt: PropTypes.string,
    })
  ),
  onFeatureClick: PropTypes.func,
};

export default ProductCards;
